import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { httpservice } from '../../services';
import logo from '../../assets/images/therame.svg';

export default function JournalEntriesDetail() {
  const [journalEntries, setJournalEntries] = useState(null);
  const [urlDetail, setUrlDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const [expired, setExpired] = useState(false);
  const [removed, setRemoved] = useState(false);
  const [decodedNotes, setDecodedNotes] = useState('');
  console.log('journalEntries', journalEntries);

  const { id } = useParams();
  const divStyle = {
    color: '#123868',
  };
  let deocedId = atob(id);
  console.log('decodeid', deocedId);
  const location = useLocation();
  const currentTime = new Date().toISOString();

  const searchParams = new URLSearchParams(location.search);
  const notes = searchParams.get('notes');

  console.log('notes', notes);
  document.title = 'Journal entry share';
  useEffect(() => {
    if (notes) {
      try {
        const decodedParam = decodeURIComponent(notes); // Decode URL encoding
        const paddedBase64 = decodedParam.padEnd(
          decodedParam.length + ((4 - (decodedParam.length % 4)) % 4),
          '=',
        ); // Fix padding
        const decoded = new TextDecoder('utf-8').decode(
          Uint8Array.from(atob(paddedBase64), (c) => c.charCodeAt(0)),
        );
        setDecodedNotes(decoded);
      } catch (error) {
        console.error('Invalid Base64 string:', error);
        setDecodedNotes('Invalid notes data');
      }
    }
  }, [notes]);

  const formattedDate = new Date().toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  const fetchJournalEntry = async () => {
    try {
      setLoading(true);
      const response = await httpservice().get(`api/v1/journal-entries/${deocedId}`);
      if (!response.data.response || response.data.response.length === 0) {
        setRemoved(true);
        return;
      }
      setJournalEntries(response.data.response[0]);
    } catch (error) {
      console.error('Error fetching journal entry:', error);
    } finally {
      setLoading(false);
    }
  };
  console.log('process.env.REACT_APP_ADMIN_ENDPOINT', process.env.REACT_APP_ADMIN_ENDPOINT);
  const fetchLinkDetails = async () => {
    const link = notes
      ? `${process.env.REACT_APP_ADMIN_ENDPOINT}/Journal/${id}/?notes=${notes}`
      : `${process.env.REACT_APP_ADMIN_ENDPOINT}/Journal/${id}`;
    // const link = notes
    // ? `https://theramedevapi.genixits.com/Journal/${deocedId}/?notes=${notes}`
    // : `https://theramedevapi.genixits.com/Journal/${deocedId}`;

    try {
      const response = await httpservice().post('api/v1/getLinkDetails/link', {
        link,
      });
      const details = response.data.response.rows[0];
      if (details) {
        setUrlDetails(details);
      } else {
        setExpired(true);
      }
    } catch (error) {
      console.error('Error fetching link details:', error);
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor = '#F2F2F2';
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    fetchLinkDetails();
  }, [deocedId]);

  const setOpened = async () => {
    await httpservice()
      .put('api/v1/setOpened', { linkId: urlDetail?.id })
      .then((res) => {
        console.log('set expired');
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (!urlDetail) return;
    if (urlDetail?.expiryTime > currentTime) {
      if (urlDetail.isOpened == false || urlDetail.isOpened == null) {
        setValid(true);
        fetchJournalEntry();
        // setOpened();
      }
    } else {
      setValid(false);
      setExpired(true);
    }
  }, [urlDetail]);

  return (
    <div className="container-fluid px-0">
      <div className="container-fluid py-3 mx-0" style={{ backgroundColor: '#33b2ea' }}>
        {/* <img src={logo} width="232" /> */}
        <h2 className="text-white">Shared Journal Entry</h2>
      </div>
      {valid == true && journalEntries ? (
        <div className="container-fluid">
          {!loading && journalEntries && (
            <div className="row my-4 d-flex " style={divStyle}>
              <div className="container">
                <h6 className="my-3">
                  {journalEntries.journeyerName ? journalEntries.journeyerName : 'Journeyer'} has
                  chosen to share a journal entry with you from the TheraMe app. This app allows
                  users to journal their emotions and selectively share entries with others.{' '}
                </h6>
                <h6 className="my-3 ">
                  Here is the entry they have shared with you, only viewable for the next 2 days.
                </h6>
              </div>

              <div className="col-lg-12 mb-4 mt-3 px-2">
                {/* <div className="container rounded text-white px-0 " style={{ backgroundColor: '#1d1e28' }}>
                                        <h5 className="px-3 py-2">I Need</h5>
                                       
                                    </div> */}

                {/* Emotion */}
                {journalEntries?.emotion && journalEntries?.emotion !== '' && (
                  <div
                    className="container rounded text-white px-0 py-3 mb-4 shadow"
                    style={{ backgroundColor: '#32b1e8' }}
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <img
                          className="px-3 py-2"
                          alt="Emotion"
                          src={journalEntries?.imgurl}
                          width="80"
                        />
                      </div>
                      <div>
                        <span style={{ fontSize: '32px' }}>{journalEntries.emotion}</span>
                      </div>
                    </div>
                    <p className="text-white px-3">{formattedDate}</p>
                  </div>
                )}
                {/* Intensity */}
                {journalEntries?.emotionHeight && journalEntries?.emotionHeight !== '' && (
                  <div
                    className="container rounded py-2 px-0 mb-3 shadow"
                    style={{ backgroundColor: '#FFFFFF' }}
                  >
                    <p className="px-3 pt-3 fw-bold">Intensity</p>
                    <p className="px-3 pt-0">{journalEntries?.emotionHeight}</p>
                  </div>
                )}
                {/* Feelings */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.feel ? JSON.parse(journalEntries.feel) : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">What am I Feeling?</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* Body Sensation */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.bodysensation
                      ? JSON.parse(journalEntries.bodysensation)
                      : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">Body Sensation</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* Experience */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.experience ? JSON.parse(journalEntries.experience) : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">How am I being or behaving?</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* Perception */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.perception ? JSON.parse(journalEntries.perception) : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">What is my way of seeing this?</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* With Whom or What Situation */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.withWhomOrWhatSituation
                      ? JSON.parse(journalEntries.withWhomOrWhatSituation)
                      : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">
                        With Whom or What Situation activated this experience?
                      </p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* What I Need */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.whatNeed ? JSON.parse(journalEntries.whatNeed) : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">What Do I Need?</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
                {/* What I Can Do Now */}
                {(() => {
                  let arr = [];
                  try {
                    arr = journalEntries?.whatDoNow ? JSON.parse(journalEntries.whatDoNow) : [];
                  } catch {}
                  return arr && Array.isArray(arr) && arr.length > 0 ? (
                    <div
                      className="container rounded py-2 px-0 mb-3 shadow"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <p className="px-3 pt-3 fw-bold">What Can I Do Right Now?</p>
                      <p className="px-3 pt-0">{arr.join(', ')}</p>
                    </div>
                  ) : null;
                })()}
              </div>
              {decodedNotes && (
                <div className="container">
                  <div className="container shadow rounded" style={{ backgroundColor: '#FFFFFF' }}>
                    <div className="col-12 py-3">
                      <h5 className="">What Happened?</h5>
                      <p className="">{decodedNotes}</p>
                    </div>
                  </div>
                </div>
              )}

              {journalEntries?.audioPath && (
                <div className="container mt-3">
                  <div className="container shadow rounded" style={{ backgroundColor: '#FFFFFF' }}>
                    <div className="col-12 py-3">
                      <h5 className="">Voice Note</h5>
                      <audio controls style={{ width: '100%' }}>
                        <source src={journalEntries.audioPath} />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                  </div>
                </div>
              )}

              <p>
                If you're interested in using the TheraMe app to journal your own emotions and
                learning from them, you can download the app from{' '}
                <a href="https://play.google.com/store/apps/details?id=com.therame_mobile">link</a>{' '}
                and register. All journal entries are strictly private and only visible to you
                except for any specific entries you choose to share.{' '}
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="container">
          <center>
            {removed ? (
              <h5 className="text-black pt-5">
                Apologies, the shared entry has been removed by the Journeyer.
              </h5>
            ) : expired ? (
              <h5 className="text-black pt-5">Link is expired.</h5>
            ) : (
              <h5 className="text-black pt-5">Loading..</h5>
            )}
          </center>
        </div>
      )}
      <footer
        className="border border-bottom-0 border-start-0 fixed-bottom bg-white border-end-0 py-2"
        style={{ borderColor: '#32b1e8 !important', color: '#123868' }}
      >
        <div className="text-center">
          <span className="fw-bold">
            {new Date().getFullYear()} The Tea Group. All Rights Reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
